import React from "react";
import { FaFacebook, FaLinkedin, FaTwitter, FaInstagram, FaPhone, FaEnvelope, FaMapMarkerAlt, FaRegCopyright } from "react-icons/fa";
import { Link } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer text-light py-5">
      <div className="container">
        <div className="row">
          
          {/* Company Info */}
          <div className="col-md-4">
            <h4 className="fw-bold text-uppercase">CA Madhuri</h4>
            <p className="text-white">Your trusted financial & business advisory partner.</p>
            <p><FaMapMarkerAlt className="icon" /> 55B Narsi vihar, near Mandi chauraha Mathura Uttar Pradesh 281004</p>
            <p><FaPhone className="icon" />+91 79834 28842</p>
            <p><FaEnvelope className="icon" /> camadhurico@gmail.com</p>
          </div>

          {/* Quick Links */}
          <div className="col-md-4">
            <h5 className="fw-bold text-uppercase">Quick Links</h5>
            <ul className="list-unstyled">
              <li><Link to="/" className="footer-link">🏠 Home</Link></li>
              <li><Link to="/about" className="footer-link">📌 About Us</Link></li>
              <li><Link to="/services" className="footer-link">💼 Services</Link></li>
              <li><Link to="/contact" className="footer-link">📞 Contact</Link></li>
            </ul>
          </div>

          {/* Social Media */}
          <div className="col-md-4 text-center">
            <h5 className="fw-bold text-uppercase">Follow Us</h5>
            <div className="social-icons">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-icon"><FaFacebook /></a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-icon"><FaTwitter /></a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-icon"><FaLinkedin /></a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-icon"><FaInstagram /></a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="text-center mt-4">
          <p><FaRegCopyright /> {new Date().getFullYear()} CA Madhuri. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
